import { supabase } from "@/integrations/supabase/client";

export interface AuthEmailResult {
  success: boolean;
  message: string;
}

/**
 * Sends the self serve access emails through our own templated pipeline
 * instead of the built in mailer, so every email speaks in one voice.
 */
async function callPublicAuthEmail(
  action: "first_time_setup" | "reset",
  email: string,
): Promise<AuthEmailResult> {
  const { data, error } = await supabase.functions.invoke("public-auth-email", {
    body: { action, email, origin: window.location.origin },
  });

  if (error) {
    let message = "We could not send the email. Please try again.";
    try {
      const body = await (error as any)?.context?.json?.();
      if (body?.error) message = body.error;
      if (body?.message) message = body.message;
    } catch {
      // keep the friendly fallback
    }
    return { success: false, message };
  }

  const result = data as AuthEmailResult | null;
  return (
    result || { success: false, message: "We did not hear back. Please try again." }
  );
}

export const sendFirstTimeAccessEmail = (email: string) =>
  callPublicAuthEmail("first_time_setup", email);

export const sendSelfServeReset = (email: string) =>
  callPublicAuthEmail("reset", email);
